import { render, staticRenderFns } from "./elem.vue?vue&type=template&id=33f17b3e&scoped=true&"
import script from "./elem.vue?vue&type=script&lang=js&"
export * from "./elem.vue?vue&type=script&lang=js&"
import style0 from "./elem.css?vue&type=style&index=0&id=33f17b3e&scoped=true&lang=css&"
import style1 from "./elem1024.css?vue&type=style&index=1&id=33f17b3e&scoped=true&lang=css&"
import style2 from "./elem768.css?vue&type=style&index=2&id=33f17b3e&scoped=true&lang=css&"
import style3 from "./elem480.css?vue&type=style&index=3&id=33f17b3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f17b3e",
  null
  
)

export default component.exports